




import React from "react";
import "../../styles/InlandLogistics.css";
import logisticsImage from "../../images/logistics-slider.jpg";
import logistics1 from "../../assets/logistics1.jpg";
import logistics2 from "../../assets/logistics2.jpg";
import truckIcon from "../../assets/service-icon.png"; // Import the truck icon
import { Link } from "react-router-dom";

const InlandLogistics = () => {
  return (
    <div className="logistics-container">
      {/* Image Slider - Full width like homepage */}
      <div className="logistics-image-slider">
        <img src={logisticsImage} alt="Inland Logistics Slider" />
      </div>

      {/* Main Content Container */}
      <div className="logistics-content">
        {/* Content Card with title inside */}
        <div className="logistics-card">
          {/* Title with Icon - Added with blue style */}
          <div className="logistics-title-header">
            <img src={truckIcon} alt="Logistics Service" className="logistics-title-icon rotate-on-hover" />
            <h3 className="logistics-title-text">Inland Logistics</h3>
          </div>
          
          {/* Left Side - Images */}
          <div className="card-left">
            <div className="logistics-image-container first-image">
              <img src={logistics1} alt="Logistics Loading" className="logistics-img" />
            </div>
            <div className="logistics-image-container second-image">
              <img src={logistics2} alt="Logistics Transport" className="logistics-img" />
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="card-right">
            <p className="logistics-text">
              Established to cater to the Indian exporter and importer, Puyvast's Logistics division has 
              several decades of experience in providing a host of value-added services.
            </p>
            <p className="logistics-text">
              Puyvast has its own Customs House Agents License (CHA) at Chennai, Vizag, Kakinada, Bangalore, 
              Mangalore, and Karwar. Puyvast regularly clears containers from these ports and ICDs. Puyvast 
              is also registered with the Director General of Shipping (DGS) as a Multimodal Transport 
              Operator (MTO). To augment their services, Puyvast owns and operates a fleet of heavy 
              equipment, including trailers, cranes, and forklifts.
            </p>
            <p className="logistics-text">
              With the competence to undertake the carriage of cargo by sea in containers as well as break bulk, 
              Puyvast has the capacity to offer comprehensive end-to-end solutions for outward and inward transits 
              through their Freight Forwarding division and a network of overseas associates.
            </p>
            <p className="logistics-text">
              Puyvast, through their own and associated concerns, also operates their own stockyards at all major 
              ports, are registered stevedores, and have long-term tie-ups with reputed warehousing companies.
            </p>
            <div className="logistics-blue-header">
              <img src={truckIcon} alt="Equipment" className="logistics-header-icon rotate-on-hover" />
              <div className="logistics-vertical-line"></div>
              <h3 className="logistics-header-title">A partial list of equipment includes:</h3>
            </div>
            <ul className="equipment-list">
              <li>
                <span className="equipment-icon moving-truck">🚛</span> 
                <span className="equipment-text">
                  <h5>Cranes (Crawler and Truck Mounted):</h5> Capacity - 10 Mtns to 125 Mtns.
                </span>
              </li>
              <li>
                <span className="equipment-icon moving-truck">🚛</span> 
                <span className="equipment-text">
                  <h5>Forklift Trucks:</h5> Capacity - 05 Mtns to 32 Mtns.
                </span>
              </li>
              <li>
                <span className="equipment-icon moving-truck">🚛</span> 
                <span className="equipment-text">
                  <h5>Trailers:</h5> 20' & 40'.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer - Same as homepage */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default InlandLogistics;